import styled from 'styled-components'

export const StyledContainer = styled.section`
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    align-items: center;

`
